// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, putRequest, postBodyRequest, getNoAuthRequest, postNoAuthRequest } from '@/libs/axios';

import {reqUrlParam} from "@/api/const.js"

// [piliangjigou]导入数据
export const importData = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return postBodyRequest(`/api/rest/operation/batchOrgDeviceInfo/importData`, params)
}

// [piliangjigou]keyWord获取列表数据
export const getOrgDeviceInfoByKeyWord = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return getRequest('/api/rest/operation/batchOrgDeviceInfo/getOrgDeviceInfoByKeyWord', params)
}

// [piliangjigou]编辑或更新数据
export const insertOrUpdate = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return postBodyRequest('/api/rest/operation/batchOrgDeviceInfo/insertOrUpdate', params)
}

// [piliangjigou]批量通过id删除
export const delByIds = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return postRequest('/api/rest/operation/batchOrgDeviceInfo/delByIds', params)
}

// [piliangjigou]提交
export const auditSubmit = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return postRequest('/api/rest/operation/batchOrgDeviceInfo/submit', params)
}

// [piliangjigou]驳回
export const reject = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return postRequest('/api/rest/operation/batchOrgDeviceInfo/reject', params)
}

// [piliangjigou]审批通过
export const pass = (params) => {
    params[reqUrlParam] = config.resourceCenterApi;
    return postRequest('/api/rest/operation/batchOrgDeviceInfo/pass', params)
}